import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { Observable, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {
  private hubConnection: HubConnection;
  private notificationSubject: Subject<string> = new Subject<string>();
  endpoint = environment.apiUrl + 'Auditoria/INotify/';
  // endpoint = 'https://localhost:64978/' + 'INotify/'; //aqui A206

  constructor() {
    this.hubConnection = new HubConnectionBuilder()
    // Asegúrate de que la URL coincida con la configuración de tu servidor
      .withUrl(this.endpoint + 'sendNotify') 
      .build();

    this.hubConnection.on('ReceiveNotification', (message: string) => {
      this.notificationSubject.next(message);
    });
    this.hubConnection.start().catch(err => console.error(err));
  }
  
  getNotificationObservable(): Observable<string> {
    return this.notificationSubject.asObservable();
  }
}